export const JA_JP = {
  translation: {
    lang_ja: "Japanese",
    lang_en: "English",
    "Current Language": "現在の言語",
    "Language settings": "言語設定",
    "Switch to ja": "日本語に切り替え",
    "Switch to en": "英語に切り替え",
    Settings: "設定",
    "Appearance settings": "表示設定",
    Appearance: "表示",
    light: "ライト",
    dark: "ダーク",
    "Switch to light": "ライトモードに切り替え",
    "Switch to dark": "ダークモードに切り替え",
    "Wecken's Works": "過去の制作",
    Works: "制作",
    "Visit website": "公式サイトを見る",
    card_description_gif_distillery:
      "動画からGIFを手軽に作成できるMac・iPhone・iPad向けアプリ。トリミングや画質調整から書き出しまで、すべて端末内で完結します。",
    card_description_kurashiru_store_01:
      "日本最大級のレシピ動画アプリ「kurashiru」で上質な料理やスイーツを楽しめるオンラインセレクトショップ（2020年サービス終了）",
    short_descripton_kurashiru_store_01:
      "上質な食材やスイーツが手に入るアプリ内セレクトショップ",
    short_descripton_kurashiru_store_02:
      "クラシルアプリは、当時すでに日本で最も成功したレシピアプリの一つでした。しかし、この成功に満足することなく、もっと大きな市場、つまりEコマースに参入したいと考えたのです。それが「kurashiru store」プロジェクトです。",
    card_description_MBUX_01:
      "最高の車内ユーザー体験を実現するために開発された未来的でラグジュアリーな車載情報システム",
    short_description_MBUX_01: "最高の車内ユーザー体験を実現するために",
    card_description_EOW_01: "人気の高いオンライン英語辞書",
    short_description_EOW_01:
      "人気の高いオンライン英語辞書、英辞郎のリデザイン",
    "Eijiro on the WEB": "英辞郎 on the WEB",
    Detail: "詳細",
    Role: "役割",
    Tools: "使用ツール",
    Skills: "スキル",
    Challenges: "課題",
    Design: "デザイン",
    "UI/UX Designer": "UI/UXデザイナー",
    "UI/UX Design": "UI/UXデザイン",
    "UI Design": "UIデザイン",
    "UI/UX Expert": "UI/UXエキスパート",
    "Graphic Design": "グラフィックデザイン",
    "Information Architecture": "情報設計",
    "User Research": "顧客調査",
    "Usability Research": "ユーザビリティ調査",
    "International Communications and Negotiations":
      "多国籍チームでのコミュニケーションと交渉",
    "Front-end engineering": "フロントエンド開発",
    "Front-end engineer": "フロントエンドエンジニア",
    "Business English": "ビジネス英会話",
    kurashiru_store_article_paragraph_01:
      "Eコマースアプリのデザインは初めてだったので、最初はとにかくいろいろと調べました。Amazon、楽天、メルカリなど、主要なECサイトやアプリを調査しました。ECアプリだけでなく、人気のスイーツブランドのウェブサイトのデザインもリサーチしました。BAKE、Mr.チーズケーキなどのブランドサイトです。クラシルストアは特にスイーツを中心とした商品構成だったため、これらを調査することで食品の良さやブランディングを伝えるのに非常に役立ちました。",
    kurashiru_store_article_paragraph_02:
      "バナーなどのクリエイティブデザインも、このプロジェクトで学びました。ECサービスである以上、ただ動くだけのUIではダメで、商品を売る必要がありました。そのため、お客様とコミュニケーションをとるための様々な手法が必要でした。バナーもサイズや形状を変えて、お客様を惹きつけ、商品を素敵に見せるものをたくさん作りました。",
    kurashiru_store_article_paragraph_03:
      "当初は商品点数が少なく、コレクションページやカテゴリーページの重要性が低かったため、まず商品説明ページのデザインから始めました。",
    kurashiru_store_article_paragraph_04:
      "また、アカウント登録のフローは、最もユーザーが脱落し、コンバージョンに至らないまま終わってしまいやすい個所なので、非常に慎重に設計しました。この中で最も重要だったのは、お客様がアカウントを持っていなくても商品をカートに入れられるようにすることでした。一度商品をカートに入れて購入の意思決定ができてしまえば、アカウント作成とフォーム入力はごく自然に行われるようになります。もし、お客様がサービスを利用する前にアカウント作成をお願いされていた場合、もっと早い段階で脱落していたでしょう。これを実現するためには、上の画像にあるように、裏側のロジックはかなり複雑になっています。しかし、お客様から見ると、とてもクリーンでシンプルなデザインになりました。",
    mbux_article_paragraph_01:
      "私が入社したとき、製品は壊滅的な状態でした。最終的な完成バージョンであっても、システム全体が常にクラッシュし続けました。当然のことながら、顧客から多くの苦情が寄せられることになっていました。まずUI以前に、なぜそのような状況になるのか、その原因を探らなければならなりませんでした。一番大きな問題は、「日本独自」の機能が多すぎることでした。日本のGPSナビゲーションシステムは、歴史的な経緯もあり、独特の進化を遂げてきました。そのため、製品も開発プロセスも非常に複雑になっていたのです。日本独自のUIをグローバルなUIデザイン戦略に合わせるため、「この機能は本当に必要なのか」と自問自答しました。それを裏付けるために、大規模なオンライン調査も実施しました。日本のユーザーに「こういう機能はよく使いますか？」といった質問に答えてもらう定量調査です。その結果、今はもう使われなくなっている機能がたくさんあることがわかりました。これらの「ローカライズされすぎている」機能をいくつか削減し、グローバルのUIに統一しました。その結果、私が担当したバージョンではシステムの安定性が大幅に向上し、海外で標準的に使われている高度な機能を数多く取り込むことができました。",
    mbux_article_paragraph_02: "そのうちの1つがフリーテキスト検索でした。",
    mbux_article_paragraph_03:
      "先代では、都道府県から番地まで順番に選んでいく住所入力方式を主な目的地入力方法として提供していました。これは日本独自のものでした。しかし、この方法では平均的な住所を入力するのに約90秒もかかっていたのです。そこで、住所、施設名、施設カテゴリ、電話番号、郵便番号など、さまざまなキーワードに対応した目的地を、ソフトウェアキーボードですぐに入力できるようフローを再設計しました。新しいコンセプトでは、同じ住所を入力するのに10秒しかかからず、前世代の9倍ものスピードで完了しました。また、音声入力も可能なため、運転中の住所入力もより安全かつスピーディーに行えます。",
    mbux_article_paragraph_04:
      "機能をただ削減しただけではありません。重要でない機能を削減することによって、本来集中するべきローカライズの機能の開発が行えるようになりました。その一つがフリック入力です。",
    mbux_article_paragraph_05:
      "当時、日本ではすでにスマートフォンの文字入力方式として、フリック入力が普及していました。しかし、私たちが提供していたのは、たとえば市役所のタッチパネルにあるような、とても使い勝手の悪い昔ながらの50音入力方式だけでした。",
    eow_article_pargraph_01:
      "リニューアル前は、画面遷移が多すぎて使い勝手が悪いと感じていました。例文の多さで有名なアプリなので、たくさんの例文の中から最適なものを探すときに効率的に使えるようにしたいと思いました。",
    eow_article_pargraph_02:
      "一覧と詳細表示の効率的なインタラクションを実現するために、滑らかなアニメーションを実現したいと思いました。アニメーションで遷移することで、ユーザーは各インタラクションの後に迷うことがなくなるのです",
    "Wecken is a Japan-based UI/UX designer, good at mobile app UI design with a good understanding of front end engineering. This web site is designed and coded by Wecken":
      "Weckenは日本在住のUI/UXデザイナーです。モバイルアプリのUIデザインを得意とし、フロントエンド開発についても知識があります。このウェブサイトはWeckenによってデザイン、React / TypeScriptでコーディングされています。",
    "About Wecken": "Weckenについて",
    "Wecken is currently working for a company that is offering consumer mobile app, and is also working on several UI design projects on the side project.":
      "Weckenは現在、消費者向けモバイルアプリを提供している会社に勤務しており、サイドプロジェクトとしていくつかのUIデザインプロジェクトにも携わっています。",
    "Please contact me if you need help with the following types of design work.":
      "以下のようなデザイン業務でお困りの方は、ぜひご連絡ください。",
    "- Consulting UI design (for consumer and for business)":
      "・UIデザインコンサルティング（コンシューマー向け、ビジネス向け)",
    "- UI design mock-up creation using Figma":
      "・Figmaを用いたUIデザインモックアップの作成",
    "- Interpreting / Translating business English, especially IT domain":
      "・ビジネス英語（特にIT分野）の通訳・翻訳",
    "- Consulting / Designing usability research":
      "・ユーザビリティ調査の設計・コンサルティング",
    "- Consulting UI Design workshop, and holding online seminars":
      "・UIデザインワークショップのコンサルティング、オンラインセミナーの開催",
    "Here are my previous works":
      "過去の制作物に関してはこちらをご覧ください。",
    "Project manager": "プロジェクトマネージャー",
    "Scrum master": "スクラムマスター",
    Blogs: "ブログ",
    Contacts: "お問合せ",
    "I'm writing about UI design and front-end engineering":
      "UIデザインやフロントエンド開発について書いています。",
    "Integrated one of the biggest online grocery store by AEON into Kurashiru, recipe video app, and designed the user experience completely from scratch":
      "レシピ動画アプリ「クラシル」に、イオンが運営する日本最大規模の食品スーパーを統合し、ユーザー体験をゼロからデザイン。",
    "Get delivered from your favorite local supermarket within 30 minuts":
      "お近くのスーパーマーケットから30分以内に配達",
    short_descripton_netsuper_01:
      "イオンが提供するネットスーパー機能をクラシルアプリ内に組み込むことで、クラシルを利用される数百万人以上のユーザーがレシピ検索から、食材購入までワンストップで行えるようにしました。",
    netsuper_article_paragraph_01:
      "ネットスーパーならではの課題としては、まずアイテム数が挙げられます。私たちのパートナーのオンラインストアには、最大で4万点のアイテムが掲載されています。また、Amazonのような通常のECと比較して、1回の買い物でカートに入れる商品数が非常に多いことも特徴です。通常のECでは、ユーザーは1〜2点の商品をまとめて購入しますが、ネットスーパーECでは20〜40点の商品を1つのカートで購入することが一般的です。つまり、商品を探して、カートに追加するまでの操作が効率的であることが非常に重要になります。",
    netsuper_article_paragraph_02:
      "この課題に対する私のアプローチは、カテゴリーナビゲーションのエクスペリエンスを注意深くデザインすることでした。スーパーマーケットで必要なものを探している自分を想像すると、それらがどこにあるのか、頭の中で位置を確認するはずです。あるいは、買いたいものを思い出したり、インスピレーションを得たりするために、コーナーを辿るように順番に歩いていくことになるでしょう。",
    netsuper_article_paragraph_03:
      "実際のスーパーマーケットで商品を見ているのと同じような体験ができるように、カテゴリー分けや画面に表示される順番をデザインしました。",
    netsuper_article_paragraph_04:
      "また、「Kurashiru」アプリでレシピを検索したり、ECで食材を検索して購入したり、自宅に配送してもらうことができるのも、このプロジェクトの面白い点です。",
    netsuper_article_paragraph_05:
      "このユニークなユースケースのUIをデザインしました。スーパーで定期的に購入する商品のセレクトは人それぞれ異なるため、このアプリでは食材ごとに複数の結果を提案しています。",
    short_descripton_kurashiru_delivery_01:
      "クラシルデリバリーは、いつものスーパーから食料品を配達してくれる、単独のネイティブアプリでした。React Nativeの技術により、シングルソースでiOSとAndroidに対応しました。ピーコックやイオンスタイルなどのフランチャイズスーパーと提携し、東京都港区、品川区、渋谷区、中央区の一部に対応しました。",
    kurashiru_delivery_article_paragraph_01:
      "クラシルデリバリーに先立って立ち上げたクラシルネットスーパープロジェクトでは、私たちのアプリはECフロントエンドのみを提供していました。配送やカスタマーサポートなど、それ以外のサービスは完全にパートナー企業側で行っていました。",
    kurashiru_delivery_article_paragraph_02:
      "しかし、今回は配送やカスタマーサポートも請け負うサービスを提供しました。そこで、「ショッパーアプリ」というバックオフィスツールを設計する必要がありました。ショッパーアプリでは、パーソナルショッパーと呼ばれるエージェントが、エンドユーザーの代わりに店内で買い物を行い、配送手続きも行う必要がありました。",
    kurashiru_delivery_article_paragraph_03:
      "ショッパーアプリ、ECフロントエンド、さらにはECで販売する商品を管理するためのAdmin Webアプリなど、UI/UXを総合的にデザインしました。",
    skill_explanation_paragraph_01:
      "Weckenは、Figmaで製品レベルのUIモックアップを作成することを得意としており、Adobe XDやProtoPieを含む、主要なUI/UXプロトタイピング・ツールを使いこなしています。また、多くのUI/UXデザイナーと同様に、PhotoshopやIllustratorにも精通していますが、今日のワークフローにおいて最も効率的であるFigmaを好んで使用しています。",
    skill_explanation_paragraph_02:
      "UI/UXデザインにおけるクラフツマンシップを重要視し、デザインとコーディングの両方にチャレンジしています。過去のプロジェクトではTypeScript、Swift、SwiftUIで実際にコーディングを行い製品を開発しました。これは、それぞれのプラットフォームで最適なユーザー体験をデザイナーが直接ユーザーに提供することを最重要視しているからに他なりません。",
    "Show more": "さらに表示",
    "'Netsuper' Integration on Kurashiru App":
      "イオンネットスーパーをクラシルアプリに統合",
    "Shop the Best, Skip the Rest – Your Online Grocery Revolution":
      "「最高品質 即日配達」- 仕入れから配達まで自社手配でネットスーパーの完成系へ",
    "Project management (scrum)": "プロジェクト管理（スクラム）",
    kurashiru_mart_article_paragraph_01:
      "以前の「クラシルデリバリー」では、小売業者との提携により、迅速な食料品のオンラインショッピング体験を提供していました。しかし、このモデルでは本質的には「配送」の部分のみが提供価値となるため、事業の成長に大きな制約があることを認識しました。また、利用者が送料を負担することに抵抗を感じていることもわかりました。この洞察により、私たちは「ダークストア」ビジネスモデルを採用することになりました。",
    kurashiru_mart_article_paragraph_02:
      "ダークストア・モデルでは、商品を卸から仕入れ、小売パートナーを介することなく消費者に直接販売します。ダークストア店舗はオンラインのみで運営され、物理的な入店の必要がありません。これにより、在庫管理が合理化されるだけでなく、購入後の欠品を理論上ゼロにできるため、顧客満足度も向上します。",
    kurashiru_mart_article_paragraph_03:
      "このモデルを採用するにあたって、UI/UXデザインを全面的に見直す必要がありました。以前は、販売する商品に対する影響力がなかったため、その点ではショッピング体験を向上させることができませんでした。ダークストアモデルを採用したKurashiru Martでは、商品の品揃えを直接管理できるようになったため、単に迅速な配送を提供するだけでなく、ユーザーのエンゲージメントをより高め、商品を売り込むことの重要性が増しました。会員制プログラムやポイントおみくじなどの革新的な機能の導入を促し、顧客エンゲージメントと満足度をさらに向上させることに注力しました。",
    "This view was designed an coded by Wecken in React Native":
      "この画面はWeckenがデザインとコーディングの両方を行なって実装しました。",
    "Wecken aimed to provide a fun and native-app-like experience with the lottery feature. To achieve this, he utilized the device's motion sensor to facilitate the lottery drawing.":
      "Weckenは、おみくじ機能でネイティブアプリらしい楽しい体験を提供することを目指しました。これを実現するために、彼はデバイスのモーションセンサーを利用しておみくじを引く機能を実装しました。",
    short_descripton_kurashiru_mart_01:
      "Eコマースのビジネスモデルを追求する私たちの旅は、絶え間ない挑戦の歴史でした。Kurashiru Martではさらなる高みを求めて小売市場への参入という、最も過酷な最終章を迎えたのです。",
  },
}
